import React, { useEffect, useState } from 'react';
import { CreditApplicationDetailsDialog } from 'modules/creditApplicationDetails';
import { useSelector } from 'react-redux';
import { CreditApplicationEntityType } from '@trnsact/trnsact-shared-types';
import { useCreditAppDownloadWrapper } from 'modules/customers/hooks/useCreditAppDownloadWrapper';

interface Props {
  voId: string;
  setIsCreditAppDownloading: any;
}

export const CreditAppDownloadWrapper = ({ voId, setIsCreditAppDownloading }: Props) => {
  const account = useSelector((state: any) => state.account);
  const vendorProfile = useSelector((state: any) => state.vp);

  const [isOpenCADMv2, setIsOpenCADMv2] = useState(true);
  const [isPDFDownloaded, setIsPDFDownloaded] = useState(false);

  const { CADMPortalConfiguration, isLoading } = useCreditAppDownloadWrapper(voId);

  useEffect(() => {
    if (!isPDFDownloaded) {
      return;
    }
    setIsOpenCADMv2(false);
    setIsCreditAppDownloading(false);
  }, [isPDFDownloaded]);

  if (isLoading) {
    return null;
  }

  return (
    <CreditApplicationDetailsDialog
      isOpen={isOpenCADMv2}
      onClose={() => setIsOpenCADMv2(false)}
      data={{
        vo: {
          vendorOpportunityId: voId,
          entityType: CreditApplicationEntityType.CreditApp,
        } as any,
        account,
        vendorProfile,
        setIsPDFDownloaded,
        isForPDFOnly: true,
        isEditingDisabled: true,
        creditAppModalConfig: CADMPortalConfiguration?.jsonDefinition,
      }}
    />
  );
};
